import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './Header';
import { Footer } from './Footer';
import { NewsletterBar } from './NewsletterBar';
import { trackPageView } from '../lib/analytics';

export function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Debug: Log router pathname vs window pathname
    console.log('Router pathname:', pathname);
    console.log('Window pathname:', window.location.pathname);
    
    // Track page view for route changes with longer delay for title updates
    const trackingTimeout = setTimeout(() => {
      trackPageView(pathname, document.title);
    }, 200); // Increased delay to ensure page title is fully updated by Helmet

    return () => clearTimeout(trackingTimeout);
  }, [pathname]);

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <NewsletterBar />
        <Footer />
      </div>
    </HelmetProvider>
  );
}